export const INITIAL_VALUES = {
  oldPassword: '',
  newPassword: '',
  repeatNewPassword: ''
};
